// Layout math for FactiiiStrip (web and mobile): a box of a given width and
// height filled with square factiii avatars, row by row, with a "+N" badge
// taking the end of the last row when they do not all fit.

type FitInput = {
  /** Measured width of the strip, px. */
  width: number;
  /** Height the caller gave the strip, px. Always at least one row. */
  height: number;
  /** How many factiiis there are to show. */
  count: number;
  /** Avatar edge, px. */
  itemSize: number;
  /** Gap between avatars, both axes, px. */
  gap: number;
  /** Width held for the "+N" badge, px. */
  overflowWidth: number;
};

/** How many avatars the strip shows; the rest are counted by the "+N" badge. */
export const fitFactiiiStrip = ({
  width,
  height,
  count,
  itemSize,
  gap,
  overflowWidth
}: FitInput): number => {
  const footprint = itemSize + gap;
  if (count <= 0 || width <= 0 || footprint <= 0) return 0;
  // The last item in a row or column carries no trailing gap.
  const rows = Math.max(1, Math.floor((height + gap) / footprint));
  const perRow = Math.floor((width + gap) / footprint);
  if (count <= rows * perRow) return count;
  // Not everything fits: the last row gives up room for the badge. Every
  // avatar before the badge is followed by a gap.
  const lastRow = Math.max(0, Math.floor((width - overflowWidth) / footprint));
  return Math.min(count, (rows - 1) * perRow + Math.min(lastRow, perRow));
};
